import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import 'bootstrap-daterangepicker/daterangepicker.css';
import ensureDateRangePicker from 'vendor/bootstrap-daterangepicker-init';

const EVENT_MAP = {
  onShow: 'show',
  onHide: 'hide',
  onShowCalendar: 'showCalendar',
  onHideCalendar: 'hideCalendar',
  onApply: 'apply',
  onCancel: 'cancel',
};

/**
 * React wrapper for bootstrap-daterangepicker (replaces react-bootstrap-daterangepicker).
 */
const DateRangePicker = ({
  initialSettings,
  children,
  ...eventHandlers
}) => {
  const inputRef = useRef(null);
  const $pickerRef = useRef(null);

  useEffect(() => {
    let active = true;

    ensureDateRangePicker().then(() => {
      if (!active || !inputRef.current) {
        return;
      }

      const $picker = $(inputRef.current);
      $picker.daterangepicker(initialSettings || {});
      $pickerRef.current = $picker;

      Object.entries(EVENT_MAP).forEach(([prop, eventName]) => {
        const handler = eventHandlers[prop];
        if (handler) {
          $picker.on(`${eventName}.daterangepicker`, handler);
        }
      });
    });

    return () => {
      active = false;
      const $picker = $pickerRef.current;
      if ($picker) {
        $picker.data('daterangepicker')?.remove();
        $picker.off('.daterangepicker');
        $pickerRef.current = null;
      }
    };
    // Match legacy react-bootstrap-daterangepicker: init once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const child = React.Children.only(children);

  return React.cloneElement(child, {
    ref: (node) => {
      inputRef.current = node;
      const { ref } = child;
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
  });
};

export default DateRangePicker;
